export const FrameInfo = () => {
    return <h1>THIS IS THE Frame Info PAGE</h1>
};
 